import React from 'react';
import { Layout, Typography, Card, Button, Form, Input } from 'antd';
import axios from 'axios';
import withNavigate from '../components/withNavigate';
import ClientHeader from '../components/header';
import ClientFooter from '../components/footer';

const { Content } = Layout;
const { Title } = Typography;

class AdminAwsLogin extends React.Component {
  formRef = React.createRef();
  handleRedirect = () => {
    this.props.navigate('/admin/adminUserList');
  };

  componentDidMount=()=> {
    localStorage.getItem('token')&& setTimeout(()=>{this.handleRedirect()},0)
  }

  handleFinish = async () => {
    const loginFormData = this.formRef.current.getFieldsValue();
    const account = loginFormData.admin;
    const password = loginFormData.password;
    const api = process.env.REACT_APP_API_URL;
    const res = await axios.post(`${api}/login`, { account, password });
    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
      sessionStorage.setItem('userInfo', JSON.stringify(res.data));
      this.handleRedirect();
    } else {
      alert('Login failed: incorrect account or password');
    }
  };

  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Layout>
          <ClientHeader />
          <Content
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: '3rem',
              // padding: '2rem',
            }}
          >
            <div style={{ width: '100%', maxWidth: 420 }}>
              <Card
                style={{
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  borderRadius: '10px',
                  textAlign: 'center',
                   padding: '1rem 2rem'
                }}
              >
                <div style={{ marginBottom: '1.5rem' }}>
                  <img src="/assets/logo.png" alt="Logo" style={{width:220,height:160, objectFit:'contain'}} />
                </div>
                <Title level={3} style={{ marginBottom: '1.5rem' }}>Backend Managed System</Title>
                <Form
                  ref={this.formRef}
                  layout="vertical"
                  onFinish={this.handleFinish}
                >
                  <Form.Item
                    label="Account"
                    name="admin"
                    rules={[{ required: true, message: 'Please enter your account' }]}
                  >
                    <Input size="large" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please enter your password' }]}
                  >
                    <Input.Password size="large" />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      size="large"
                      block
                      style={{ borderRadius: '6px' }}
                    >
                      Login
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </div>
          </Content>
          <ClientFooter />
        </Layout>
      </Layout>
    );
  }
}

export default withNavigate(AdminAwsLogin);
